import React, { useState } from 'react';
import {
  Typography,
  Divider,
  Tooltip,
  IconButton,
  Popover
 } from '@material-ui/core';
import { toCurrency } from 'utilities/format';
import { withStyles } from '@material-ui/core/styles';
import { Info as InfoIcon } from "@material-ui/icons";
import { UnderwriteSchoolRating } from 'components/underwrite/shared';
import classNames from 'classnames';

const styles = theme => ({
  vertDivider: {
    width: 1,
    height: '100%',
    margin: '0 7px 0 4px'
  },
  grayBackground: {
    filter: 'grayscale(0.8) brightness(0.85) opacity(0.9)',
    backgroundColor: '#fff'
  }
});

const AuxInfo = ({ classes,  amherstEstimatedAMI, schoolScoreAverage, schoolDistrict, selectedContainer }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const showPopover = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  }

  return (
    <>
      <Typography variant="caption">
        Amherst AMI{' '}
        <strong>{amherstEstimatedAMI != null ? toCurrency(amherstEstimatedAMI, 0) : 'N/A'}</strong>        
      </Typography>
      <Divider className={classes.vertDivider} />
      <Typography variant="caption">
        Avg School Score <strong>{schoolScoreAverage != null ? schoolScoreAverage.toFixed(1) : 'N/A'}</strong>
      </Typography>
      {schoolScoreAverage != null &&
        <Tooltip title=''>
          <IconButton size='small' onClick={showPopover} style={{ marginLeft: 4 }}>
            <InfoIcon fontSize='small' />
          </IconButton>
        </Tooltip>
      }
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classNames(selectedContainer?.viewingReadonlyMode && classes.grayBackground)} style={{ width: 200, padding: '8px 16px' }}>
          <Typography variant='h6' style={{ fontSize: '1rem', textAlign: 'center' }}>{`${schoolDistrict || 'District Unknown'}`}</Typography>
          <UnderwriteSchoolRating selectedContainer={selectedContainer} />
        </div>
      </Popover>
    </>
  );
}

export default withStyles(styles)(AuxInfo);